import React from 'react';

import PropTypes from 'prop-types';
import { Container, Inner, TextInner, CloseBtn, Highlight } from './styles';

import ModalGlobalStyle from '~/styles/showModalGlobal';
import { FaInfoCircle } from 'react-icons/fa';
import parse from 'html-react-parser';

export default function ModalProjetos({
  title,
  subtitle,
  text,
  objective,
  executingUnit,
  coordination,
  targetAudience,
  globalValue,
  duration,
  toSupport,
  regionalCoverage,
  closeModal,
}) {
  return (
    <>
      <ModalGlobalStyle />
      <Container>
        <Inner>
          <CloseBtn onClick={closeModal} />
          <h2>{title}</h2>
          <h3>{subtitle}</h3>
          <Highlight>
            <b>
              <FaInfoCircle size={22} />
              Para apoiar este projeto, anote:
            </b>
            <ul>{parse(toSupport)}</ul>
          </Highlight>
		  <h4>Objetivo Geral</h4>
          <TextInner>{parse(objective)}</TextInner>
					  
          <TextInner>{parse(text)}</TextInner>
                      
          <ul>
			<li>
              <b>Unidade Executora: </b>
              {executingUnit}
            </li>			
            {/* <li className="paraapoioar">
              <b>Para apoiar este projeto, anote: </b>
              <span>{parse(toSupport)}</span>
            </li> */}
            
            {/* <li className="coordination">
              <b>Coordenação: </b>
              <span>{parse(coordination)}</span>
            </li>*/}
            <li>
              <b>Público Alvo: </b>
              {targetAudience}
            </li>       
            <li>
              <b>Abrangência: </b>
              {regionalCoverage}
            </li>
            <li>
              <b>Duração: </b>
              {duration}
            </li>
			<li>
              <b>Orçamento Global: </b>
              {globalValue}
            </li>
          </ul>
        </Inner>
      </Container>
    </>
  );
}
ModalProjetos.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  objective: PropTypes.string,
  executingUnit: PropTypes.string,
  coordination: PropTypes.string,
  targetAudience: PropTypes.string,  
  globalValue: PropTypes.string,
  duration: PropTypes.string,
  toSupport: PropTypes.string,
  regionalCoverage: PropTypes.string,
  closeModal: PropTypes.func,
};
